import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading, Text } from "@cinch-labs/design-system";
import { AlertIcon, CardIcon, ElectricIcon, LinkIcon, MakeModelIcon, RangeIcon } from "@cinch-nx/design-system-icons";
import styles from "./feature-card.module.css";
const ComponentMap = {
    "arrow-right": /*#__PURE__*/ _jsx(LinkIcon, {
        size: 24
    }),
    alert: /*#__PURE__*/ _jsx(AlertIcon, {
        size: 24
    }),
    card: /*#__PURE__*/ _jsx(CardIcon, {
        size: 24
    }),
    electric: /*#__PURE__*/ _jsx(ElectricIcon, {
        size: 24
    }),
    "vehicle-front": /*#__PURE__*/ _jsx(MakeModelIcon, {
        size: 24
    }),
    range: /*#__PURE__*/ _jsx(RangeIcon, {
        size: 24
    })
};
export const FeatureCard = ({ title , body , icon  })=>/*#__PURE__*/ _jsxs("div", {
        className: styles.card,
        "data-testid": "feature-card",
        children: [
            icon ? ComponentMap[icon] : null,
            /*#__PURE__*/ _jsx(Heading, {
                element: "h3",
                className: styles.title,
                children: title
            }),
            /*#__PURE__*/ _jsx(Text, {
                className: styles.body,
                children: body
            })
        ]
    });
